import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Controller, useForm } from 'react-hook-form'
import { makeStyles } from '@material-ui/core/styles'
import { Button, Typography, Checkbox, FormControlLabel } from '@material-ui/core'
import Select from 'common/components/Select'
import styles from './EditSystemCalibrationCo2Form.module.scss'
import { withLocalize } from 'react-localize-redux'
import { blue } from '@material-ui/core/colors'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import cx from 'classnames'
import { Alert } from '@material-ui/lab'
import { LoadingButton } from '@mui/lab'

const useStyles = makeStyles(() => ({
  input: {
    [`& fieldset`]: {
      borderRadius: 30,
      borderColor: 'grey'
    },
    '& label.Mui-focused': {
      color: 'rgba(0,155,229,1)'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'grey'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'grey'
      },
      '&:hover fieldset': {
        borderColor: 'grey'
      },
      '&.Mui-focused fieldset': {
        borderColor: 'rgba(0,155,229,1)'
      }
    }
  },
  switch: {
    '& .Mui-checked': {
      color: 'rgba(0,155,229,1)'
    },
    '& .MuiSwitch-colorSecondary': {
      color: 'rgba(255,255,255)'
    },
    '& .MuiSwitch-colorSecondary.Mui-checked': {
      color: 'rgba(0,155,229,1)'
    },
    '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
      backgroundColor: 'rgba(0,155,229,1)',
      color: 'rgba(0,155,229,1)'
    },
    '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-thumb': {
      color: 'rgba(0,155,229,1)'
    },
    '& .MuiSwitch-colorSecondary.Mui-checked:hover': {
      backgroundColor: blue[100]
    },
    '& .MuiSwitch-thumb': {
      transform: 'translateY(-3px)',
      width: '21px',
      height: '21px'
    },
    '& .MuiSwitch-track': {
      backgroundColor: 'rgba(33,33,33, 0.4)'
    }
  }
}))

const EditSystemCalibrationCo2Form = props => {
  const classes = useStyles()

  const [allDeviceSelected, setAllDevicesSelected] = useState(false)
  const [autocalibrationInfo, setAutocalibrationInfo] = useState()

  const { isSubmitting, translate, onSubmit, submitError, initialVentilationType } = props

  const { handleSubmit, register, errors, setValue, control } = useForm()
  const calibrationOptions = [
    { label: translate('co2CalibrationModal.calibration48h'), value: 1 },
    { label: translate('co2CalibrationModal.calibration24h'), value: 2 },
    { label: translate('co2CalibrationModal.calibration7d'), value: 3 },
    { label: translate('co2CalibrationModal.calibration15'), value: 4 },
    { label: translate('co2CalibrationModal.calibrationOff'), value: 5 }
  ]
  const getInitialCalibration = initialValue => {
    return calibrationOptions.find(object => {
      return object.value === initialValue
    })
  }
  const initialCalibration = getInitialCalibration(initialVentilationType)
  const [callibrationType, setCalibrationType] = useState(initialVentilationType)
  useEffect(() => {
    switch (callibrationType) {
      case 1: {
        setAutocalibrationInfo(translate('co2CalibrationModal.info48'))
        break
      }
      case 2: {
        setAutocalibrationInfo(translate('co2CalibrationModal.info24'))
        break
      }
      case 3: {
        setAutocalibrationInfo(translate('co2CalibrationModal.info7'))
        break
      }
      case 4: {
        setAutocalibrationInfo(translate('co2CalibrationModal.info15'))
        break
      }
      case 5: {
        setAutocalibrationInfo(translate('co2CalibrationModal.infoOff'))
        break
      }
    }
  }, [callibrationType])
  const handleSelectAllDevices = event => {
    setAllDevicesSelected(event.target.checked)
  }

  const onClickCancel = () => {
    props.hideModal()
  }

  const error = () => {
    const message = translate('submitErrors.unknown')

    return (
      <Alert
        severity='error'
        className={styles.errorMessage}
        style={{ display: submitError ? 'flex' : 'none' }}
      >
        {message}
      </Alert>
    )
  }

  return (
    <div className={styles.modalContainer}>
      <Typography className={styles.header}>{translate('co2CalibrationModal.title')}</Typography>
      <div className={styles.modal}>
        <div className={styles.subtitle}>
          <p>{translate('co2CalibrationModal.subtitle')}</p>
        </div>
        <form
          noValidate
          onSubmit={handleSubmit(onSubmit)}
          onKeyDown={ev => {
            if (ev.key === 'Enter') {
              ev.preventDefault()
            }
          }}
        >
          <div className={styles.secondPage}>
            <div className={styles.cselect}>
              <Controller
                className={styles.wrapperSelect}
                render={({ onChange, name }) => (
                  <div className={styles.custom}>
                    <Select
                      handleChange={e => {
                        setValue(name, e.value)
                        setCalibrationType(e.value)
                      }}
                      error={errors.useType}
                      options={calibrationOptions}
                      defaultValue={initialCalibration}
                      className={cx(classes.selector, styles.selector, {
                        [styles.hasError]: errors.useType
                      })}
                    />
                  </div>
                )}
                control={control}
                name='autocalibrationco2'
                defaultValue={initialCalibration ? initialCalibration.value : null}
              />
            </div>
            <div className={styles.infoPublicWrapper}>
              <div className={styles.iconPublic}>
                <InfoOutlinedIcon />
              </div>
              <Typography className={styles.deviceCalibrationInfoLabel}>
                {autocalibrationInfo}
              </Typography>
            </div>
            <div className={styles.modalNote}>
              <p>{translate('co2CalibrationModal.note')}</p>
            </div>
            <div>
              <FormControlLabel
                className={styles.selectAllCheckboxForm}
                control={
                  <Checkbox
                    className={cx(styles.checkbox)}
                    classes={{ checked: styles.checkedBox }}
                    name='selectAll'
                    id='selectAll'
                    onChange={handleSelectAllDevices}
                    inputRef={register()}
                    isChecked={allDeviceSelected}
                  />
                }
                label={translate('applyToAllDevices')}
              />
            </div>
            <div className={styles.infoPublicWrapper}>
              <div className={styles.iconPublic}>
                <InfoOutlinedIcon />
              </div>
              <Typography className={styles.deviceLightsInfoLabel}>
                {translate('applyToAllDevicesInfo')}
              </Typography>
            </div>
            {error()}
            <div className={styles.buttons}>
              <div className={styles.buttonWrapper}>
                <LoadingButton
                  type='submit'
                  fullWidth
                  variant='contained'
                  className={styles.buttonAdd}
                  disabled={isSubmitting || errors.timeInterval}
                  loading={isSubmitting}
                  isLoading={isSubmitting}
                  loadingPosition='end'
                >
                  {translate('saveChanges')}
                </LoadingButton>
              </div>
              <div className={styles.buttonWrapper}>
                <Button
                  fullWidth
                  variant='contained'
                  disableRipple
                  className={styles.buttonCancelar}
                  disabled={isSubmitting}
                  isLoading={isSubmitting}
                  onClick={onClickCancel}
                >
                  {translate('cancel')}
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

EditSystemCalibrationCo2Form.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  submitError: PropTypes.any,
  translate: PropTypes.func.isRequired
}

export default withLocalize(EditSystemCalibrationCo2Form)
